import React from 'react'

import type { UserRole } from '../modals/ModalShareLoan'
import { addSpacesToPascalCase } from '../../services/helpers'

type ShareLoanListNameCellProps = {
	row: UserRole
}

const ShareLoanListNameCell = ({
	row: { markedForDeletion, user },
}: ShareLoanListNameCellProps) => {
	const { name, role } = user

	return (
		<div
			style={{
				opacity: markedForDeletion ? 0.5 : 1,
				textDecoration: markedForDeletion ? 'line-through' : 'none',
			}}
		>
			<div className="font-medium">{name}</div>
			<div className="text-sm text-gray-500">
				{addSpacesToPascalCase(role)}
			</div>
		</div>
	)
}

export default ShareLoanListNameCell
